<div class="det-panel">
  @if(detections().length > 0){
  <div class="det-container">
    <mat-form-field class="det-filter-input">
      <mat-label>Buscar producto</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Ej: Energizante">
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>
    <div class="det-toolbar">
      <div class="det-filter-toggle">
        <mat-slide-toggle [checked]="filterBoxes()" (change)="onFilterBoxesChange($event.checked)">
          <span>Ocultar no relevantes</span>
        </mat-slide-toggle>
      </div>
      <button class="main-visibility" mat-icon-button (click)="changeAllVisibility();$event.preventDefault()">
        <mat-icon class="material-symbols-outlined">
          {{ is_all_visible ? 'visibility' : 'visibility_off' }}
        </mat-icon>
      </button>
    </div>



    <mat-accordion class="det-accordion">
      <div *ngFor="let detection of finalFilteredDetections(); trackBy: trackByDetectionKey">
        <mat-expansion-panel class="det-panel-item" hideToggle>
          <mat-expansion-panel-header class="det-panel-header">
            <mat-panel-title>
              <span class="det-count"
                [ngStyle]="{'border-color': 'rgba(' + detection.value.color.r + ',' + detection.value.color.g + ',' + detection.value.color.b + ', 1)'}">
                {{detection.value.data.length}}
              </span>
              {{detection.key}}
            </mat-panel-title>
            <button mat-icon-button (click)="toggleVisibility(detection.key);$event.stopPropagation()">
              <mat-icon class="material-symbols-outlined">
                {{ detection.value.visible ? 'visibility' : 'visibility_off' }}
              </mat-icon>
            </button>
          </mat-expansion-panel-header>

          <div class="det-box" *ngFor="let box of detection.value.data">

            <div class="det-table">
              <div class="det-box-header" [attr.id]="'det-box-header-' + box.id" (click)="toggleDetails(box)" role="button" tabindex="0"
                (keydown.enter)="toggleDetails(box)" (keydown.space)="toggleDetails(box)">
                <button mat-button class="det-view-btn" (click)="toggleBoxVisibility(box); $event.stopPropagation()" extended>
                  <!-- {{ box.visible ? 'Ocultar' : 'Mostrar' }} -->
                  <mat-icon class="material-symbols-outlined">
                    {{ box.visible ? 'visibility' : 'visibility_off' }}
                  </mat-icon>
                </button>
                <span class="det-box-id">{{box.name}} </span>
                <span [class]="box.score > (0.5) ? 'det-score-in' : 'det-score-out'">
                  SCORE: {{box.score | fixedTwoDecimals}}
                </span>
                <mat-icon class="material-symbols-outlined det-collapse-icon">
                  {{ isCollapsed(box) ? 'expand_more' : 'expand_less' }}
                </mat-icon>
              </div>
              <div class="det-details" *ngIf="!isCollapsed(box)">
                <div class="det-row" *ngFor="let entry of getBoxEntries(box)">
                  <span class="det-key">{{ entry.key }}</span>
                  <span class="det-val">{{ entry.value }}</span>
                </div>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </div>
    </mat-accordion>
  </div>
  }@else{
  <div class="det-empty">No se encontraron detecciones en la imagen</div>
  }
</div>
